import { FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { ReceivedMessageCaleClassifications } from "./ReceivedMessageCaleClassifications";
import { ReceivedMessageCalePreferences } from "./ReceivedMessageCalePreferences";
import { ReceivedMessageCaleGroupings } from "./ReceivedMessageCaleGroupings";
import { ReceivedCaleSpecialties } from "./ReceivedCaleSpecialties";
import { IDefaultFieldsProps } from "../models";
import { useTranslation } from "react-i18next";
import { ReceivedMessageCalendars } from "./ReceivedMessageCalendars";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.";

export const DefaultFields = memo(({ automationCode }: IDefaultFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item sm={12} textAlign={"end"}>
        <SwitchInput
          name="showAppAndOnlineCalendar"
          label={t(translationPath + "show_app_and_online_calendar")}
        />
        <SwitchInput name="enable" label={t(translationPath + "enable")} />
      </Grid>

      <ReceivedMessageCaleClassifications automationCode={automationCode} />

      <ReceivedMessageCalePreferences automationCode={automationCode} />

      {automationCode !== "26" && (
        <ReceivedMessageCaleGroupings automationCode={automationCode} />
      )}

      {automationCode === "26" && <ReceivedMessageCalendars />}

      {automationCode !== "21" && <ReceivedCaleSpecialties />}
    </>
  );
});
